import { createStore, createLogger } from 'vuex'
import auth from './modules/auth'
import home from './modules/home'
import business from './modules/business'
import product from './modules/product'
import website from "./modules/website";
import dashboard from "./modules/dashboard";
import service from './modules/service'
const debug = process.env.NODE_ENV !== 'production'

export default createStore({
    modules: {
        auth,
        home,
        business,
        product,
        website,
        dashboard,
        service
    },
    strict: debug,
    plugins: debug ? [createLogger()] : []
})
